import { GeneralInputProps } from '@/components/GeneralInputs/type';
import {
  FormInput,
  FormInputProps,
} from '@moneyforward/ap-frontend-components';
import { memo, useMemo } from 'react';
import { FieldValues } from 'react-hook-form';

export type TextTypeProps<TFieldValues extends FieldValues> =
  FormInputProps<TFieldValues>;

type TextTypeInputProps<TFieldValues extends FieldValues> =
  TextTypeProps<TFieldValues> & GeneralInputProps;

const InnerTextTypeInput = <TFieldValues extends FieldValues>({
  control,
  inputId,
  rules,
  inputProps: _inputProps,
  name,
  onChangeAfter,
  placeholder,
}: TextTypeInputProps<TFieldValues>) => {
  const inputProps = useMemo(() => {
    return {
      ..._inputProps,
      placeholder: placeholder,
    };
  }, [placeholder, _inputProps]);

  return (
    <FormInput<TFieldValues>
      control={control}
      inputId={inputId}
      rules={rules}
      inputProps={inputProps}
      name={name}
      onChangeAfter={onChangeAfter}
    />
  );
};
InnerTextTypeInput.displayName = 'InnerTextTypeInput';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const TextTypeInput = memo(
  InnerTextTypeInput
) as typeof InnerTextTypeInput;
TextTypeInput.displayName = 'TextTypeInput';
